import {Series} from './widget.series';

export class TimelineSeries {
    yMin : any;
    yMax : any;
    xMin : any;
    xMax : any;
    DataPointName: string;
    TrendSeriesId:string;
    Unit:string;    
    Resolution: number;
    Series: Series[];
    IsNonArchived:boolean = false;
}